import Form from "rc-field-form";
import { Rule } from "rc-field-form/lib/interface";
import { PropsWithChildren } from "react";
import Error from "@src/autoDebit/components/Error/Error";

interface IRenderFormField extends PropsWithChildren {
  id: string;
  rules?: Rule[];
  renderProps: (topProps: PlainObject) => React.ReactNode;
  dependencies?: string[];
  initialValue?: string;
}

const RenderFormField = ({
  id,
  rules,
  renderProps,
  dependencies,
  initialValue,
}: IRenderFormField) => {
  return (
    <Form.Field
      name={id}
      rules={rules}
      key={id}
      dependencies={dependencies}
      initialValue={initialValue}
    >
      {(props, meta) => {
        const topLevelProps = {
          id,
          errorComponent: () => <Error>{meta.errors}</Error>,
          ...props,
        };
        return renderProps(topLevelProps);
      }}
    </Form.Field>
  );
};

export default RenderFormField;
